export default function IconRoundChevronRight({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#CDCDCD" />
            <path
                d="M12.6246 10L8.87461 13.75L8.34961 13.225L11.5746 10L8.34961 6.775L8.87461 6.25L12.6246 10Z"
                fill="#767676"
            />
        </svg>
    )
}
